import React from "react";
import Layout from "../components/newComponents/Layout";
import Card from "../components/newComponents/Card";
import CardHeader from "../components/newComponents/CardHeader";
import BottomNavbar from "../components/newComponents/BottomNavbar";
import classes from "./AccountPage.module.css";

const AccountPage = () => {
  return (
    <Layout>
      <Card>
        <CardHeader title="Account Details" />
        <div className={classes.avatar}>
          <img
            src="/assets/images/user.png"
            alt="avatar"
            className={classes.avatar_img}
          />
        </div>
        <p className={classes.msisdn}>+236 67638....</p>

        <div className={classes.points_container}>
          <img
            src="/assets/images/star.png"
            alt="points"
            className={classes.star}
          />
          <p className={classes.point}>76</p>
        </div>

        <div className={classes.divider}></div>

        <CardHeader title="Leader Board" style={{ padding: 0 }} />

        <div className={classes.leaderboard_section}>
          <div className={classes.leaderboard_header}>
            <div className={classes.leaderboard_header_item}>
              <p className={classes.item}>Rank</p>
            </div>
            <div className={classes.leaderboard_header_item}>
              <p className={classes.item}>Msisdn</p>
            </div>
            <div className={classes.leaderboard_header_item}>
              <p className={classes.item}>Points</p>
            </div>
          </div>

          <div className={classes.leaderboard_content}>
            <div className={classes.leaderboard_content_item}>
              <p className={classes.content_item}>1</p>
            </div>
            <div className={classes.leaderboard_content_item}>
              <p className={classes.content_item}>+236...</p>
            </div>
            <div className={classes.leaderboard_content_item}>
              <p className={classes.content_item}>60</p>
            </div>
          </div>

          <div className={classes.leaderboard_content}>
            <div className={classes.leaderboard_content_item}>
              <p className={classes.content_item}>2</p>
            </div>
            <div className={classes.leaderboard_content_item}>
              <p className={classes.content_item}>+236...</p>
            </div>
            <div className={classes.leaderboard_content_item}>
              <p className={classes.content_item}>55</p>
            </div>
          </div>
        </div>
      </Card>
      <BottomNavbar active={4} />
    </Layout>
  );
};

export default AccountPage;
